import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import "whatwg-fetch"
import TInputForm from "../../common/TInputForm";
import ConnectButtonForm from "../../common/ConnectButtonForm";
import WindowEventHelper from "../../../lib/WindowEventHelper";

class Tistory2TwitterForm extends Component {

	componentDidMount() {
		const { plugin, data, onChange } = this.props
		if (!plugin.active) {
			onChange(update(data, {
				setting: {
					$set: {
						prefix: ''
					}
				},
				validated: {
					$set: data.setting.secret && data.setting.token
				}
			}))
		}

		WindowEventHelper.add("message", this.handleReceivePostMessage)
	}

	componentWillUnmount() {
		WindowEventHelper.remove("message", this.handleReceivePostMessage)
	}

	@autobind
	handleConnect() {
		window.open('/oauth/twitter','TwitterAuth','width=900,height=400,toolbar=no,menubar=no,location=no,scrollbars=no,status=no');
	}

	@autobind
	handleReceivePostMessage(e) {
		const { data, onChange } = this.props

		if (e.data && e.data.name === 'Tistory2Twitter') {
			onChange(update(data, {
				setting: {
					token: {
						$set: e.data.token
					},
					secret: {
						$set: e.data.secret
					}
				},
				validated: {
					$set: true
				}
			}))
		}
	}

	@autobind
	handleChangePrefix(value) {
		const { data, onChange } = this.props
		onChange(update(data, {
			setting: {
				prefix: {
					$set: value
				}
			},
			validated: {
				$set: !!data.setting.secret && !!data.setting.token
			}
		}))
	}

	render() {
		const { data, plugin } = this.props
		return (
			<div className="desc_plugin13">
				<p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

				<div className="info_plugin">
					<div className="item_set item_sub">
						말머리
						<TInputForm type="text" className="tf_set tf_set140" title="말머리 입력" placeholder="[#Tistory]" value={data.setting.prefix}
									onChange={this.handleChangePrefix} />
					</div>
					<span className="screen_out">주소 미리보기</span>
					<p className="box_plugin">
						<span className="txt_em">{data.setting.prefix}</span>
						글 제목 http://test.tistory.com/123
					</p>
				</div>
				
				<div className="wrap_btn">
					<ConnectButtonForm connected={!!data.setting.secret && data.setting.token} onClick={this.handleConnect} />
					<span className="txt_other">연결 페이지가 보이지 않으시면 브라우저의 팝업 허용 여부를 확인해 주세요.</span>
				</div>
                {this.props.saveButton()}
			</div>
		)
	}
}

Tistory2TwitterForm.propTypes = {
	plugin: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired
}

export default Tistory2TwitterForm
